import { Box, Button, Typography } from '@mui/material';
import { Link } from "react-router-dom";

const AppOauthError = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: "#3f4652",
      }}
    >
      <Typography variant="h5" style={{ color: 'white' }}>
        لطفا اپلیکیشن موبایل خود را بروز رسانی کنید
      </Typography>
      <br/>
      <Button variant="contained">
        <Link to="https://app.umlang.com/" style={{ textDecoration: "none",color:"white" }}>
         دریافت آخرین نسخه
        </Link>

      </Button>
    </Box>
  );
};

export default AppOauthError;
